import React, { useContext, Fragment } from 'react'
import { Typography } from '@material-ui/core'
import moment from 'moment'
import DatePickerRange from '../../../../components/filters/DatePickerRange'
import { LossesFiltersContext } from '../../../../context/LossesFiltersContext'
import { defaultFormatTimeZone } from '../../../../utils/consts'

export default function DateRange (): JSX.Element {
  const { filters, setFilters } = useContext(LossesFiltersContext)
  const onChange = (initialDate: moment.Moment, finalDate: moment.Moment) => {
    setFilters({
      dateRange: {
        initialDate: initialDate.format('YYYY-MM-DD'),
        finalDate: finalDate.format('YYYY-MM-DD'),
        ...defaultFormatTimeZone
      }
    })
  }

  return (
    <Fragment>
      <Typography id="discrete-slider-custom" gutterBottom>Período</Typography>
      <DatePickerRange
        defaultInitialValue={moment(filters.dateRange?.initialDate)}
        defaultFinalValue={moment(filters.dateRange?.finalDate)}
        onChange={onChange}
      />
    </Fragment>
  )
}
